import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7hy8qb5pq9: FaireBrandEntity = {
  token: "b_7hy8qb5pq9",
  type: "brand",
  name: "The Sun & My Soul Bath Bomb Soak Wellness Gifts",
  avatarUrl:
    "https://cdn.faire.com/fastly/9a98d0820af7e75bc649518a19365d59137c205d17befe17f34bc89964c3a81e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/64430b5cba28c5fd5ae44f7fff77d08209c423ead1697ede88f3ca35876ad668.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9a98d0820af7e75bc649518a19365d59137c205d17befe17f34bc89964c3a81e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/64430b5cba28c5fd5ae44f7fff77d08209c423ead1697ede88f3ca35876ad668.jpeg",
  location: "London, GBR",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 97,
  isTopShop: true,
  isInsider: false,
  description:
    "Gifts that feel like a hug💝 We create handmade self-care gifts in the UK using natural, vegan ingredients. Made in small batches, our products are plastic-free or 100% recyclable, and cruelty-free. All of our wellness treats are designed to bring a little sunshine and uplifting energy to every day.\n\nExplore our curated wellness gifts, including beautiful bath bombs, luxury Himalayan bath salts, aromatherapy shower steamers, crystals and cosy cotton socks.\n\nBehind the brand:\n\nHey, I am Jutta! Without self-care, I wouldn’t have the resilience or self-awareness I have today. Growing up with mental health issues, I felt so alone. It taught me how important is to build a healthy and caring relationship with myself, and it became my priority.\n\nMy purpose is to empower others to take care of themselves not only on special occasions, but every single day.\n\nI started The Sun & My Soul in 2020, with the simple mission to create products that help you on your self-love journey and promote relaxing.\n\nYou can build inspiring self-care rituals that slot right into your lifestyle and start showing up as the highest version of you, every day of the week.\n\nWhat inspired the name The Sun & My Soul? 🌞\n\nNothing makes me happier than the sun. Whenever the sun comes out, I feel grateful for everything I have, and connected to every person on this planet. Something about sunshine on my face makes me feel like my soul is smiling!",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:07.131Z",
    importedBy: "entity-db-cli",
  },
};
